// extracted by mini-css-extract-plugin
export default {"root":"MainPC_root__lA0fo","header":"MainPC_header__c2tvc","flex":"MainPC_flex__HIj8-"};